var React = require('react');

function InformationLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M23.67 47.01A22.69 22.69 0 011 24.67v-.18A23.44 23.44 0 0124 1h.35a22.71 22.71 0 0122.67 22.34v.28a23.4 23.4 0 01-23 23.37l-.35.02zm.66-44h-.31a21.41 21.41 0 00-21 21.39v.25a20.69 20.69 0 0020.67 20.37h.32a21.39 21.39 0 0021-21.37v-.27A20.7 20.7 0 0024.35 3l-.02.01z","key":0}),React.createElement("path",{"d":"M24 29.01a1 1 0 01-1-1v-14a1 1 0 112 0v14a1 1 0 01-1 1zm.03 5a1.5 1.5 0 11-.06-3h.15a1.53 1.53 0 011.37 1.46 1.488 1.488 0 01-.42 1.08 1.44 1.44 0 01-1.04.46z","key":1})]);
}

InformationLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = InformationLight;

InformationLight.default = InformationLight;
